// Bootstrap

import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

// var tooltipTriggerList = [].slice.call(
// 	document.querySelectorAll('[data-bs-toggle="tooltip"]')
// );
// var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
// 	return new bootstrap.Tooltip(tooltipTriggerEl);
// });

// var popoverTriggerList = [].slice.call(
// 	document.querySelectorAll('[data-bs-toggle="popover"]')
// );
// var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
// 	return new bootstrap.Popover(popoverTriggerEl);
// });

// Custom

// Custom
import InitGsap from './InitGsap';
import initFancybox from './fancybox';
import InitSwiper from './swiper';
import initBlockVideo from './blockVideo';

InitSwiper();
initFancybox();
InitGsap();
initBlockVideo();

// Navbar scroll behaviour
(function () {
	const navbar = document.querySelector('#wrapper-navbar .navbar');
	if (!navbar) return;

	function onScroll() {
		if (window.scrollY > 10) {
			navbar.classList.add('navbar--scrolled');
		} else {
			navbar.classList.remove('navbar--scrolled');
		}
	}

	window.addEventListener('scroll', onScroll, { passive: true });
	onScroll();
})();
